import { logger } from '@zep/core-logger';
import { useOpenWindow } from '@/hooks';
import { useIsInExternalPlatform } from '@/shared/externalPlatform';
import { cn } from '@/utils/tailwind.util';
import { PublicQuizTooltip } from './PublicQuizTooltip';
interface AuthorTagChipProps {
  authorName: string;
  isOfficial?: boolean;
  authorHashId: string;
}
export const AuthorTagChip = ({
  authorName,
  isOfficial,
  authorHashId
}: AuthorTagChipProps) => {
  const openWindow = useOpenWindow();
  const isInExternalPlatform = useIsInExternalPlatform();
  const handleClick = (e: React.MouseEvent) => {
    if (isInExternalPlatform) return;
    e.preventDefault();
    e.stopPropagation();
    logger.track('click_user_profile');
    openWindow(`/profile/${authorHashId}`);
  };
  return <div className={cn('group inline-flex w-fit items-center gap-4xs rounded-xl border-[1px] border-alternative px-xs py-3xs', !isInExternalPlatform && 'cursor-pointer')} onClick={handleClick} data-sentry-component="AuthorTagChip" data-sentry-source-file="AuthorTagChip.tsx">
      <span className={cn('truncate text-center text-body-sm-semibold text-neutral', !isInExternalPlatform && 'group-hover:text-assistive')}>
        {authorName}
      </span>
      {isOfficial && !isInExternalPlatform && <PublicQuizTooltip triggerIconSize={'2xs'} onClick={handleClick} />}
    </div>;
};